// extracted by mini-css-extract-plugin
export default {"container":"TextSection_container__a+0BR","title":"TextSection_title__OedUu","text":"TextSection_text__0uKfL","blur1":"TextSection_blur1__o1cmK","blur2":"TextSection_blur2__lLISx"};